import React from 'react';
import { NextPage } from 'next';
import PrivacyPolicy from 'templates/company/PrivacyPolicy';
import { SEO } from 'templates/layout';

const Privacy: NextPage = () => {
  return (
    <>
      <SEO title="Privacy Policy" />
      <PrivacyPolicy />
    </>
  );
};

export default Privacy;
